import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { MaintenanceService } from 'src/app/services/maintenance.service';
import { Maintenance } from 'src/app/models/maintenance';
import { MaintenanceLine } from 'src/app/models/maintenance-line';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';

@Component({
  selector: 'app-maintenance-list',
  templateUrl: './maintenance-list.component.html',
  styleUrls: ['./maintenance-list.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class MaintenanceListComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  maintenances:Maintenance[] = [];
  loading:boolean = false;
  total:number = 0;

  constructor(private mainServ:MaintenanceService) { 
    this.date1.setDate(this.date1.getDate() - 6);
  }

  ngOnInit() {
    this.search();
  }

  search() {
    this.loading = true;
    this.mainServ.getMaintenances(this.date1, this.date2)
      .then(maintenances => {
        this.maintenances = maintenances;
        this.loading = false;
        this.calcTotalTotal();
      });
  }

  calcTotal(lines:MaintenanceLine[]) {
    return lines.map(ln => ((ln.quantity * ln.price) - ((ln.quantity * ln.price) * (ln.discount / 100))) * (ln.iva*1 + 1))
      .reduce((ant, act) => ant + act, 0);
  }

  calcTotalTotal() {
    this.total = 0;
    this.maintenances.forEach(main => {
      this.total += this.calcTotal(main.lines); 
    });
  }

}
